import {Component, Input} from '@angular/core';
import {CommunicationDto} from '../../../../Models/Communication/communication.interface';
import {CommunicationWidgetDto} from '../../../../Models/Communication/communication-widget.interface';

@Component({
  selector: 'app-communication-item',
  templateUrl: './communication-item.component.html',
  styleUrls: ['./communication-item.component.scss'],
  standalone: false
})
export class CommunicationItemComponent {
  @Input() communication!: CommunicationDto | CommunicationWidgetDto;
}
